export const MAIL_INVITE= "MAIL_INVITE"
export const EDIT_SURVEY= "EDIT_SURVEY"
export const SAVE_QUESTION_ANSWER= "SAVE_QUESTION_ANSWER"
export const FINAL_SUBMISSION_QUESTIONS_ANSWERS= "FINAL_SUBMISSION_QUESTIONS_ANSWERS"
export const LIST_SURVEY = "LIST_SURVEY"
export const GET_QUESTION = "GET_QUESTION"

export const QUESTION_SUCCESS = "QUESTION_SUCCESS"
export const QUESTION_ERROR = "QUESTION_ERROR"

export const SURVEY_SUCCESS = "SURVEY_SUCCESS"
export const SURVEY_ERROR = "SURVEY_ERROR"


export const LIST_HORIZONTAL = "LIST_HORIZONTAL"
export const LIST_VERTICAL = "LIST_VERTICAL"

export const HORIZONTAL_SUCCESS = "HORIZONTAL_SUCCESS"
export const VERTICAL_SUCCESS = "VERTICAL_SUCCESS"

export const HORIZONTAL_ERROR = "HORIZONTAL_ERROR"
export const VERTICAL_ERROR = "VERTICAL_ERROR"